/**
 * components/controls/StatusFilter.jsx
 */

import { __ } from "@wordpress/i18n";
import { ChevronDown } from "lucide-react";
import {
    useCrudListState,
    useCrudListDispatch,
    ACTIONS,
} from "../../context/CrudContext";

export default function StatusFilter() {
    const dispatch = useCrudListDispatch();
    const state = useCrudListState();

    return (
        <select
            value={state.status}
            onChange={(e) =>
                dispatch({
                    type: ACTIONS.SET_STATUS,
                    payload: e.target.value,
                })
            }
            className="w-full sm:w-auto bg-white hover:text-inherit border border-gray-200 rounded-md ps-4 pe-8 py-2 text-sm focus:outline-none focus:ring-2 focus:ring-accent"
        >
            <option value="">{__("All Status", "wpbean-product-gallery-slider-for-woocommerce")}</option>
            <option value="publish">{__("Published", "wpbean-product-gallery-slider-for-woocommerce")}</option>
            <option value="draft">{__("Draft", "wpbean-product-gallery-slider-for-woocommerce")}</option>
            <option value="trash">{__("Trash", "wpbean-product-gallery-slider-for-woocommerce")}</option>
        </select>
    );
}
